import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {changeLocale} from './actions';


class WithChangeLocaleUnConnected extends React.Component {
    static propTypes = {
        _locale: PropTypes.string.isRequired,
        children: PropTypes.func.isRequired,
        changeLocale: PropTypes.func.isRequired
    };

    render() {
        return this.props.children({locale: this.props._locale, changeLocale: this.props.changeLocale});
    }
}

const mapStateToProps = (state) => ({_locale: state.languageProvider.locale});

const mapDispatchToProps = {changeLocale};

export const WithChangeLocale = withRouter(connect(mapStateToProps, mapDispatchToProps)(WithChangeLocaleUnConnected));
